import { baseApi } from "@/shared/api";
import type { ImportWorkerResponse } from "./types";

export const importWorkerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    importWorker: builder.mutation<ImportWorkerResponse, FormData>({
      query: (formData) => ({
        url: "/api/hr/workers/import/",
        method: "POST",
        body: formData,
        credentials: "include" as const,
        timeout: 180000,
      }),
      invalidatesTags: [{ type: "NGOWorkers" as const, id: "LIST" }],
    }),
  }),
});

export const { useImportWorkerMutation } = importWorkerApi;
